export enum eEnv {
  DEV = 'development',
  PROD = 'production',
  TEST = 'test',
  LOCAL = 'localhost',
}

export const dateFormat = 'DD.MM.YYYY';
export const dateTimeFormat = 'DD.MM.YYYY HH:mm';

export const notificationsRefetchIntervalInMiliseconds = 2 * 60 * 1000;

export const exportDataLimit = 10000;

export const ResourceDisplayNameMaxLength = 300; // keep in sync with StaticSettings.EstimationItemEntity.NameMaxLength on BE

export const MaxTenantLogoSizeBytes = 2 * 1024 * 1024; // keep in sync with StorageUploads.MaxFileSizeBytes on BE
export const MaxTenantLogoSizeMb = 2;
export const SupportedTenantLogoImageFormats = [
  // keep in sync with StorageUploads.AllowedMimeTypes on BE
  'image/png',
  'image/jpeg',
  'image/webp',
  'image/svg+xml',
];

export const APP_VERSION_HEADER_NAME = 'x-app-version';

export enum TextDirection {
  ARABIC = 'ae',
  RTL = 'rtl',
  LTR = 'ltr',
}

export enum HtmlElementAttribute {
  DIR = 'dir',
}

export enum LogoType {
  DARK_MODE = 'DARK_MODE',
  NORMAL = 'NORMAL',
}

export enum EventType {
  CSS_LOADED = 'app-css-loaded',
  MOUSE_DOWN = 'mousedown',
}
